<span>{{message}}</span>
<ul *ngIf="availableApps">
  <li *ngFor='let app of availableApps'><a id="{{app.webAppName}}" (click)="navigateToApp(app)" >{{app.webAppTitle}}</a></li>
</ul>